import styles from './donut-chart-tooltip.module.css';
import { DonutChartBullet } from './donut-chart-bullet';

export enum DonutChartTooltipColor {
  NEUTRAL = 'neutral',
  POSITIVE = 'positive',
  NEGATIVE = 'negative',
}

const COLOR_CLASS_MAP: Record<DonutChartTooltipColor, string> = {
  [DonutChartTooltipColor.NEUTRAL]: 'detailValueNeutral',
  [DonutChartTooltipColor.POSITIVE]: 'detailValuePositive',
  [DonutChartTooltipColor.NEGATIVE]: 'detailValueNegative',
};

function getValueClassName(valueColor?: DonutChartTooltipColor): string {
  return valueColor ? COLOR_CLASS_MAP[valueColor] : 'detailValueNeutral';
}

export interface DonutChartTooltipDetail {
  label: string;
  secondaryLabel?: string;
  value: string;
  valueColor?: DonutChartTooltipColor;
}

export interface DonutChartTooltipTitle {
  color: string;
  label: string;
  value: string;
}

export interface DonutChartTooltipProps {
  title: DonutChartTooltipTitle;
  details?: DonutChartTooltipDetail[];
}

export function DonutChartTooltip({ title, details }: DonutChartTooltipProps) {
  return (
    <div className={styles.tooltipContainer}>
      <div className={styles.titleContainer}>
        <DonutChartBullet color={title.color} />
        <span className={styles.titleLabel}>{title.label}</span>
        <span className={styles.titleValue}>{title.value}</span>
      </div>

      {details && details.length > 0 ? (
        <div className={styles.detailsContainer}>
          {details.map(({ label, secondaryLabel, value, valueColor }) => (
            <div className={styles.detailItem} key={label}>
              <div className={styles.detailLabelContainer}>
                <span className={styles.detailLabel}>{label}</span>
                {secondaryLabel ? (
                  <span className={styles.detailSecondaryLabel}>{secondaryLabel}</span>
                ) : null}
              </div>
              <span className={styles[getValueClassName(valueColor)]}>{value}</span>
            </div>
          ))}
        </div>
      ) : null}
    </div>
  );
}
